import React from 'react';
import { Helmet } from '@okapi/helmet-react';
import { useSelector, connect } from 'react-redux';
import { memo } from 'common/hocs/memo';
import { getGtmCode, getPageModel } from 'domains/pageModel/store/selectors';
import { RootState } from 'stores/reducers';
import { GoogleAnalyticsScript } from 'common/components/google-analytics-script';

const mapStateToProps = (state: RootState) => ({
  id: getGtmCode(state),
});

const ConnectedGoogleAnalyticsScript = connect(mapStateToProps)(GoogleAnalyticsScript);

export const PageMeta: React.FC = memo(() => {
  const modelJson = useSelector(getPageModel);

  return modelJson ? (
    <>
      <ConnectedGoogleAnalyticsScript />
      <Helmet>
        <title>{modelJson.seoProperties?.pageTitle}</title>
        <meta name="description" content={modelJson.seoProperties?.metadescription ?? undefined} />
        <link href={modelJson.header.faviconImage} rel="shortcut icon" type="image/x-icon" />
        <link
          rel="apple-touch-icon"
          href="https://cdn.leroymerlin.ru/lmru/image/upload/v1/other/microfronts/touch-icon-iphone.jpg/file.jpg"
        />
        <link
          rel="apple-touch-icon"
          sizes="152x152"
          href="https://cdn.leroymerlin.ru/lmru/image/upload/v1/other/microfronts/touch-icon-ipad-retina.jpg/file.jpg"
        />
        <link
          rel="apple-touch-icon"
          sizes="76x76"
          href="https://cdn.leroymerlin.ru/lmru/image/upload/v1/other/microfronts/touch-icon-ipad.jpg/file.jpg"
        />
        <link
          rel="apple-touch-icon"
          sizes="120x120"
          href="https://cdn.leroymerlin.ru/lmru/image/upload/v1/other/microfronts/touch-icon-iphone-retina.jpg/file.jpg"
        />
      </Helmet>
    </>
  ) : null;
});
